import React from 'react';
import styled from 'styled-components';
import { Color } from 'core';
import LoadingDots from './LoadingDots';

interface Props {
  text?: string;
}

export const BuildingStatusIndicator = ({ text = 'Creating' }: Props) => {
  return (
    <BuildingPill>
      <LoadingDots size="small" />
      <BuildingText>{text}</BuildingText>
    </BuildingPill>
  );
};

const BuildingPill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%);
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 4px 12px;
`;

const BuildingText = styled.span`
  font-size: 12px;
  color: ${Color.primaryBlue};
  font-weight: 500;
`;